<template>
  <div class="health-container">
    <Search></Search>
    <TabBar :hideSecondMenu="true"></TabBar>
    <MedicationGuidance></MedicationGuidance>
    <div class="content">
      <div class="content-left">
        <div class="content-left--item">
          <swiper ref="mySwiper" :options="swiperOptions" class="swriper-box">
            <swiper-slide v-for="item of bannerList" :key="item.id">
              <div class="img-box" @click="goArtDetail(item.id)">
                <img :src="item.image_input" alt="" />
                <div class="tip">{{ item.title }}</div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="pagination-list">
            <span
              v-for="num of bannerList.length"
              :key="num"
              :class="active === num - 1 ? 'active' : ''"
              @click="changeIndex(num - 1)"
            >
              {{ num }}
            </span>
          </div>
        </div>
        <!-- 行业资讯 -->
        <div
          class="content-left--item"
          v-for="item of infoList.slice(0, 1)"
          :key="item.id"
        >
          <div class="item-title">
            <span class="tip" @click="goDepartment(item.id, item.title)">
              {{ item.title }}
            </span>
            <span class="more" @click="goDepartment(item.id, item.title)">
              更多>>>
            </span>
          </div>
          <div class="item-art">
            <h4 @click="goArtDetail(item.news[0].id)">
              {{ item.news[0].title }}
            </h4>
            <p>
              {{ item.news[0].synopsis.slice(0, 50) }}...<span
                @click="goArtDetail(item.news[0].id)"
                >[详细]</span
              >
            </p>
          </div>
          <div class="item-info">
            <ul>
              <li v-for="val of item.news.slice(1)" :key="val.id">
                <span>高以翔猝死 突发心搏骤停，心肺复苏如何做？</span>
                <span>2019-11-28</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- 剩下类目 -->
        <div
          class="content-left--item"
          v-for="item of infoList.slice(1, 13)"
          :key="item.id"
        >
          <div class="item-title">
            <span class="tip" @click="goDepartment(item.id, item.title)">
              {{ item.title }}
            </span>
            <span class="more" @click="goDepartment(item.id, item.title)">
              更多>>>
            </span>
          </div>
          <div class="item-art other">
            <div class="other-left">
              <img :src="item.news[0].image_input[0]" alt="" />
            </div>
            <div class="other-right">
              <div class="tip" @click="goArtDetail(item.news[0].id)">
                {{ item.news[0].title }}
              </div>
              <p>
                {{ item.news[0].synopsis.slice(0, 60) }}...<span
                  @click="goArtDetail(item.news[0].id)"
                  >[详细]</span
                >
              </p>
            </div>
          </div>
          <div class="item-info">
            <ul>
              <li v-for="val of item.news.slice(1)" :key="val.id">
                <span>{{ val.title }}</span>
                <span>{{ val.add_time }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div
          class="content-right--item"
          v-for="item of infoList.slice(13)"
          :key="item.id"
        >
          <div class="item-title">
            <span class="tip" @click="goDepartment(item.id, item.title)">
              {{ item.title }}
            </span>
            <span class="more" @click="goDepartment(item.id, item.title)">
              更多>>>
            </span>
          </div>
          <div class="item-art other">
            <div class="other-left">
              <img :src="item.news[0].image_input[0]" alt="" />
            </div>
            <div class="other-right">
              <div class="tip" @click="goArtDetail(item.news[0].id)">
                {{ item.news[0].title }}
              </div>
              <p>
                {{ item.news[0].synopsis.slice(0, 35) }}...<span
                  @click="goArtDetail(item.news[0].id)"
                  >[详细]</span
                >
              </p>
            </div>
          </div>
          <div class="item-info">
            <ul>
              <li v-for="val of item.news.slice(1)" :key="val.id">
                {{ val.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import TabBar from "@/components/pc/nav/TabBar";
import MedicationGuidance from "@/components/pc/information/MedicationGuidance";
import { getNews } from "@api/public";
export default {
  name: "HealthInformation",
  components: {
    Search,
    TabBar,
    MedicationGuidance
  },
  data() {
    return {
      bannerList: [],
      iconList: [],
      infoList: [],
      active: 0,
      swiperOptions: {
        loop: true,
        autoplay: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          type: "custom"
        },
        on: {
          slideChangeTransitionEnd: () => {
            if (this.swiper) {
              this.active = this.swiper.activeIndex;
            }
          }
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    getNews().then(res => {
      this.iconList = res.data.cate;
      sessionStorage.setItem("iconList", JSON.stringify(this.iconList));
      this.bannerList = res.data.banner;
      this.infoList = res.data.list;
    });
  },
  methods: {
    changeIndex(active) {
      this.active = active;
      this.swiper.slideTo(active);
    },
    goDepartment(id, title) {
      this.$router.push({
        path: "departmentClassification",
        query: {
          id: id,
          title: title
        }
      });
    },
    goArtDetail(id) {
      this.$router.push({
        path: "articleDetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.health-container
  background #fff
  .content
    width 1200px
    margin 20px auto 0
    display flex
    &-left
      width 880px
      display flex
      flex-wrap wrap
      justify-content space-between
      &--item
        width 420px
        position relative
        margin-bottom 30px
        .swriper-box
          height 250px
          cursor pointer
          .img-box
            height 250px
            position relative
            img
              width 100%
              height 100%
            .tip
              width 100%
              height 40px
              line-height 40px
              background rgba(0, 0, 0, 0.3)
              position absolute
              bottom 0
              color #fff
              font-size 14px
              padding-left 6px
        .pagination-list
          position absolute
          bottom 8px
          right 3px
          z-index 10
          span
            display inline-block
            width 20px
            height 20px
            margin-right 3px
            border 1px solid #999
            font-family Verdana
            font-size 14px
            color #fff
            text-align center
            background #333
            line-height 20px
            cursor pointer
            &.active
              background #ff5c4d
        .item-title
          height 38px
          line-height 38px
          border-bottom 2px solid #ccc
          display flex
          justify-content space-between
          position relative
          .tip
            font-size 18px
            cursor pointer
          .more
            cursor pointer
            .more-a
              font-size 12px
              color #005ea7
              font-family '宋体'
          &:after
            content ''
            display inline-block
            position absolute
            height 2.5px
            width 40%
            background #14c5ed
            bottom -2px
        .item-art
          padding 10px
          width 420px
          margin 0 auto
          h4
            height 25px
            font-weight bold
            font-size 15px
            overflow hidden
            cursor pointer
            &:hover
              color #377bee
          p
            font-family 'Microsoft yahei'
            color #333
            line-height 22px
            span
              color #377bee
              font-family '宋体'
              cursor pointer
          &.other
            display flex
            padding 15px 10px
            .other-left
              width 165px
              height 105px
              margin-right 10px
              img
                width 100%
                height 100%
            .other-right
              flex 1
              .tip
                height 25px
                font-weight bold
                font-size 15px
                overflow hidden
                cursor pointer
                &:hover
                  color #377bee
              p
                color #888888

        .item-info
          margin-top 10px
          padding-top 10px
          border-top 1px dotted #c0c0c0
          width 430px
          margin 0 auto
          ul
            padding 0 10px
           li
            height 28px
            line-height 28px
            padding-left 8px
            font-size 14px
            color #555
            display flex
            justify-content space-between
            position relative
            &:before
              content ''
              display inline-block
              position absolute
              width 3px
              height 3px
              background #333
              border-radius 50%
              top 12px
              left 2px
            span
              &:last-child
                font-size 12px
                color #888
    &-right
      flex 1
      margin-left 20px
      &--item
        border 1px solid #eee
        margin-bottom 10px
        .item-title
          height 38px
          line-height 38px
          display flex
          justify-content space-between
          position relative
          background #f7f7f7
          padding 0 10px
          .tip
            font-size 14px
            color #555
          .more
            cursor pointer
            .more-a
              font-size 12px
              color #005ea7
              font-family '宋体'
        .item-art
          &.other
            display flex
            padding 10px
            .other-left
              width 105px
              height 90px
              margin-right 10px
              img
                width 100%
                height 100%
            .other-right
              flex 1
              .tip
                height 25px
                font-weight bold
                font-size 15px
                overflow hidden
                cursor pointer
                &:hover
                  color #377bee
              p
                color #888888
                line-height 22px
                font-family '宋体'
                display -webkit-box !important
                overflow hidden
                text-overflow ellipsis
                word-break break-all
                -webkit-box-orient vertical
                -webkit-line-clamp 3
                span
                  color #377bee
                  cursor pointer
        .item-info
          padding-top 10px
          border-top 1px dotted #c0c0c0
          margin 10px auto
          font-family: 'Microsoft yahei';
          ul
            padding 0 10px
           li
            height 28px
            line-height 28px
            padding-left 8px
            font-size 14px
            color #555
            display flex
            justify-content space-between
            position relative
            &:before
              content ''
              display inline-block
              position absolute
              width 3px
              height 3px
              background #333
              border-radius 50%
              top 12px
              left 2px
</style>
